import Toolbar from './components/Toolbar.vue'
import View from './components/View.vue'
import Footer from './components/Footer.vue'
import LoadingBar from './components/LoadingBar.vue'
import Paginate from './components/Paginate.vue'
const GlobalComponents = {
    install(Vue) {
        Vue.component('toolbar', Toolbar)
        Vue.component('core-view', View)
        Vue.component('bottom-view', Footer)
        Vue.component('loadingBar', LoadingBar)
        Vue.component('paginate', Paginate)
    }
}

export default GlobalComponents